import { SearchResultFlightDirectionFragment, ExchangeVariantPriceInfoFragment } from '@websky/graphql';
import { SegmentValue, TravellerValue } from '../../../../Checkout/types';

export type ExchangeTravellerValue = TravellerValue & { isSelected: boolean };

export type ExchangeSegmentValue = SegmentValue & ExchangeSegmentState;

export interface ExchangePassengersState {
	[passengerId: string]: boolean;
}

export interface ExchangeSegmentState {
	selectedDate: Date;
	isSelected: boolean;
}

export interface ExchangeSegmentsState {
	[segmentId: string]: ExchangeSegmentState;
}

export interface ExchangeFlight {
	groupId: string;
	priceId: string;
	actualPriceId?: string;
}

export interface ExchangeVariantsState {
	selectedFlights: ExchangeFlight[];
	flightDirections: SearchResultFlightDirectionFragment[];
	exchangeVariantPriceInfo: ExchangeVariantPriceInfoFragment[];
}

export enum PaymentStatus {
	Success = 'success',
	Failed = 'failed'
}

export type LoadingType =
	| 'idle'
	| 'all'
	| 'exchange-variants'
	| 'exchange-price'
	| 'create-exchange'
	| 'refuse-exchange'
	| 'auto-create-exchange';

export interface ExchangeState {
	error: string | null;
	exchangeVariants: ExchangeVariantsState;
	passengers: ExchangePassengersState;
	segments: ExchangeSegmentsState;
	paymentStatus: PaymentStatus;
	isLoading: LoadingType;
}

export type AnyStateWithExchange<T = {}> = T & {
	exchange: ExchangeState;
};

export interface ExchangeTargetSelectedFlight {
	priceId: string;
	groupId?: string;
}

export type ExchangeTargetFareGroupWithPrices = {
	fareFamily?: { id?: string };
	prices?: Array<{ flight?: { id?: string } }>;
};

export type ExchangeTargetFlightDirectionWithLegs = {
	legs?: Array<{ pricesForFareGroups?: ExchangeTargetFareGroupWithPrices[] }>;
};

export type ExchangeTargetFlightReason =
	| 'selectionIncomplete'
	| 'owSingleFlight'
	| 'firstNotInReturnCombo'
	| 'firstInReturnCombo'
	| 'rtComboPriceMismatch';

export interface ExchangeTargetFlightDecision {
	targetFlightIndex: number | undefined;
	reason: ExchangeTargetFlightReason;
	isFirstFlightInReturnCombo: boolean | null;
	returnLegFlightIds: string[];
	firstPriceId: string | null;
}
